module.exports = {
  smallMobileBreakpoint: 320,
  mobileBreakpoint: 479,
  smallScreenWidth: 768,
  midScreenWidth: 969,
  largeScreenBreakpoint: 969,
  tabsLayoutBreakpoint: 1200,
};
